/** Resize a textarea to fit its content (up to any CSS max-height). */
export function autosize(el: HTMLTextAreaElement) {
  el.style.height = "auto";
  el.style.height = `${el.scrollHeight}px`;
}
